import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-download-page',
  templateUrl: './app-download-page.component.html',
  styleUrls: ['./app-download-page.component.scss']
})
export class AppDownloadPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
